import React from "react";

const SvgMainBg = props => (
  <svg className="main-bg" id="main-bg" viewBox="0 0 1440 4235" {...props}>
    <defs>
      <path
        d="M1216,624 C1223.73251,624 1230,617.732506 1230,610 C1230,602.267494 1223.73251,596 1216,596 C1208.26749,596 1202,602.267494 1202,610 C1202,617.732506 1208.26749,624 1216,624 Z"
        id="path-1"
      />
    </defs>
    <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
      <path
        d="M298,1863.1703 L298,1938.3806"
        id="Line-Copy-2"
        stroke="#FDDD00"
        strokeWidth={2}
        strokeLinecap="square"
      />
      <path
        id="main-reporting-align"
        d="M298,1962 C305.732506,1962 312,1955.73251 312,1948 C312,1940.26749 305.732506,1934 298,1934 C290.267494,1934 284,1940.26749 284,1948 C284,1955.73251 290.267494,1962 298,1962 Z"
        stroke="#FDDC00"
        strokeWidth={10}
        fill="#073D61"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M267,1503.1703 L267,1579.61774"
        id="Line-Copy"
        stroke="#FDDD00"
        strokeWidth={2}
        strokeLinecap="square"
      />
      <rect
        id="Rectangle"
        fill="#073D61"
        x={0}
        y={0}
        width={1440}
        height={791}
      />
      <g transform="translate(1288.000000, 0.000000)">
        <path
          d="M14,0 L14,113 C14,168.228475 58.771525,213 114,213 L148,213 L152,213"
          id="Path-3"
          stroke="#FFFFFF"
          strokeWidth={17}
          opacity={0.156306612}
        />
        <path
          id="intro-title-align"
          d="M14,139 C21.7325064,139 28,132.732506 28,125 C28,117.267494 21.7325064,111 14,111 C6.26749364,111 0,117.267494 0,125 C0,132.732506 6.26749364,139 14,139 Z"
          stroke="#2D5B79"
          strokeWidth={10}
          fill="#073D61"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g id="Group-35" transform="translate(0.000000, 262.000000)">
        <path
          d="M380,0 L290.784191,4.26325641e-14 C259.856245,7.57834698e-14 234.784191,25.072054 234.784191,56 L234.784191,243.828761 C234.784191,274.756707 209.712137,299.828761 178.784191,299.828761 L56,299.828761 C25.072054,299.828761 4.84106469e-13,324.900815 4.19220214e-13,355.828761 L-7.10542736e-15,410 C-7.19916818e-14,440.927946 25.072054,466 56,466 L380,466"
          id="Path-3-Copy"
          stroke="#FFFFFF"
          strokeWidth={17}
          opacity={0.156306612}
          transform="translate(190.000000, 233.000000) scale(-1, 1) translate(-190.000000, -233.000000) "
        />
        <path
          d="M145,161 C152.732506,161 159,154.732506 159,147 C159,139.267494 152.732506,133 145,133 C137.267494,133 131,139.267494 131,147 C131,154.732506 137.267494,161 145,161 Z"
          id="Stroke-15-Copy-6"
          stroke="#2D5B79"
          strokeWidth={10}
          fill="#073D61"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M380,396 C387.732506,396 394,389.732506 394,382 C394,374.267494 387.732506,368 380,368 C372.267494,368 366,374.267494 366,382 C366,389.732506 372.267494,396 380,396 Z"
          id="Stroke-15-Copy-7"
          stroke="#2D5B79"
          strokeWidth={10}
          fill="#073D61"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M466.893681,3460.58492 L1079.52639,3457.94146 L1165.64511,3458.55274 C1193.25865,3458.74874 1215.80274,3436.52243 1215.99874,3408.90889 C1215.99958,3408.79059 1216,3408.67229 1216,3408.55399 L1216,2908.70312 C1216,2881.08889 1193.61424,2858.70312 1166,2858.70312 L1020.97151,2858.70312 L313.703125,2858.70312 C271.177199,2858.70312 236.703125,2824.22905 236.703125,2781.70312 L236.703125,2753 L206.848518,2753 C206.848518,2753 148.672866,2753 148.672866,2811.12168 L148.672866,2957.72825 C148.672866,2957.72825 148.672866,3015.84993 206.848518,3015.84993 L215.958394,3015.84993 L215.958394,3192.80032 C215.958394,3249.54861 159.157412,3249.54861 159.157412,3249.54861 L156.860551,3249.54861 L0,3249.54861 C0,3249.54861 0,3490.36574 0,3972 C118.982588,3972 178.473883,3972 178.473883,3972 L178.473883,3698.04781 L183.505209,3497.30605 C184.052593,3475.46635 202.02145,3458.10555 223.86706,3458.31004 L466.893681,3460.58492 Z"
        id="Fill-1"
        fill="#093D5F"
      />
      <path
        d="M1440,1353 L962,1353 L957.442056,1524.40048 L957.442056,1524.40048 C972.216855,1524.40048 984.194196,1536.37783 984.194196,1551.15263 L984.194196,1801.83136 C984.194196,1828.8437 962.333528,1850.76114 935.321284,1850.8312 L655.46877,1851.55704 C655.187508,1854.28928 655,1857.11964 655,1860.13972 C655,1901.37991 675.601165,1922 716.803494,1922 L1440,1922 L1440,1353 Z"
        id="Fill-1"
        fill="#F0F1F6"
      />
      <path
        id="trigger"
        d="M961.355368,1508.79663 L961.355368,1399.86629 C961.355368,1351.4819 1009.7737,1351.4819 1009.7737,1351.4819 L1218.59361,1351.4819 L1218.59361,1379.23833 C1218.59361,1379.23833 1218.59361,1436.84642 1276.2421,1436.84642 L1440,1436.84642 L1440,790 L0,790 L0,1316.24708 L233.728923,1316.24708 L236.397834,1481.91088 L279.121772,1501.40289 L612.712239,1510 L961.355368,1508.79663 Z"
        fill="#073D61"
      />
      <path
        id="main-server-align"
        d="M237.5,1158.17054 L275.695312,1158.17054"
        stroke="#009EE3"
        strokeWidth={18}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="main-fingerprint-align"
        d="M237.5,1358.17054 L275.695312,1358.17054"
        stroke="#009EE3"
        strokeWidth={18}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="main-submit-align"
        d="M237.5,2629.17054 L275.695312,2629.17054"
        stroke="#009EE3"
        strokeWidth={18}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="main-form-align"
        d="M179,4216.34619 L179,3970"
        stroke="#009EE3"
        strokeWidth={18}
        strokeLinejoin="bevel"
        strokeDasharray="18 8"
      />
      <path
        id="main-uti-align"
        d="M993.5,1574.17054 L1031.69531,1574.17054"
        stroke="#009EE3"
        strokeWidth={18}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="main-reporting-cloud"
        d="M147.755123,2191.29673 L147.755123,2449.06611 C147.755123,2449.06611 136.521669,2513.27288 200.709275,2513.27288 L238.736815,2513.27288 L369.208818,2513.27288 L1006.1418,2513.27288 L1006.1418,2524.79323 C1006.1418,2524.79323 1006.1418,2589 1070.3294,2589 L1264.81466,2589 C1264.81466,2589 1329,2589 1329,2524.79323 L1329,2487.18109 C1329,2487.18109 1328.98868,2434.19794 1280.85986,2424.49874 L1280.85986,2358.58181 C1280.85986,2358.58181 1280.85986,2294.37503 1216.67452,2294.37503 L1023.25125,2294.37503 L1023.25125,2191 L147.755123,2191.29673 Z"
        fill="#EEF0F5"
      />
      <path
        id="main-trading-align"
        d="M267,851 C274.732506,851 281,844.732506 281,837 C281,829.267494 274.732506,823 267,823 C259.267494,823 253,829.267494 253,837 C253,844.732506 259.267494,851 267,851 Z"
        stroke="#FDDC00"
        strokeWidth={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M267,851 L267,1023.77176"
        id="Line"
        stroke="#FDDD00"
        strokeWidth={2}
        strokeLinecap="square"
      />
      <path
        id="main-matching-align"
        d="M267,1608 C274.732506,1608 281,1601.73251 281,1594 C281,1586.26749 274.732506,1580 267,1580 C259.267494,1580 253,1586.26749 253,1594 C253,1601.73251 259.267494,1608 267,1608 Z"
        stroke="#FDDC00"
        strokeWidth={10}
        fill="#073D61"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M259,2844.22396 L259,2924.5"
        id="Line-Copy-3"
        stroke="#FDDD00"
        strokeWidth={2}
        strokeLinecap="square"
      />
      <path
        id="main-insight-align"
        d="M259,2946 C266.732506,2946 273,2939.73251 273,2932 C273,2924.26749 266.732506,2918 259,2918 C251.267494,2918 245,2924.26749 245,2932 C245,2939.73251 251.267494,2946 259,2946 Z"
        stroke="#FDDC00"
        strokeWidth={10}
        fill="#073D61"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="main-main-line"
        d="M1440,474 L1272.89381,474 C1241.96587,474 1216.89381,499.072054 1216.89381,530 L1216.89381,789.86655 L1216.89381,970.48092 C1216.89381,1001.40887 1191.82176,1026.48092 1160.89381,1026.48092 L291.885118,1026.48092 C260.957172,1026.48092 235.885118,1051.55297 235.885118,1082.48092 L235.885118,1449.17521 C235.885118,1480.10316 260.957172,1505.17521 291.885118,1505.17521 L934.638784,1505.17521 C965.56673,1505.17521 990.638784,1530.24727 990.638784,1561.17521 L990.638784,1801.54484 C990.638784,1832.47279 965.56673,1857.54484 934.638784,1857.54484 L291.885118,1857.54484 C260.957172,1857.54484 235.885118,1882.61689 235.885118,1913.54484 L235.885118,2799.12178 C235.885118,2830.04973 260.957172,2855.12178 291.885118,2855.12178 L1160.89381,2855.12178 C1191.82176,2855.12178 1216.89381,2880.19383 1216.89381,2911.12178 L1216.89381,3403.24198 C1216.89381,3434.16993 1191.82176,3459.24198 1160.89381,3459.24198 L861.03606,3459.24198 L235,3459.24198 C204.072054,3459.24198 179,3484.31404 179,3515.24198 L179,3972"
        stroke="#009EE3"
        strokeWidth={18}
        style={{
          strokeLinecap: "round"
        }}
      />
      <path
        id="main-yellow-line"
        d="M1440,474 L1272.89381,474 C1241.96587,474 1216.89381,499.072054 1216.89381,530 L1216.89381,789.86655 L1216.89381,970.48092 C1216.89381,1001.40887 1191.82176,1026.48092 1160.89381,1026.48092 L291.885118,1026.48092 C260.957172,1026.48092 235.885118,1051.55297 235.885118,1082.48092 L235.885118,1449.17521 C235.885118,1480.10316 260.957172,1505.17521 291.885118,1505.17521 L934.638784,1505.17521 C965.56673,1505.17521 990.638784,1530.24727 990.638784,1561.17521 L990.638784,1801.54484 C990.638784,1832.47279 965.56673,1857.54484 934.638784,1857.54484 L291.885118,1857.54484 C260.957172,1857.54484 235.885118,1882.61689 235.885118,1913.54484 L235.885118,2799.12178 C235.885118,2830.04973 260.957172,2855.12178 291.885118,2855.12178 L1160.89381,2855.12178 C1191.82176,2855.12178 1216.89381,2880.19383 1216.89381,2911.12178 L1216.89381,3403.24198 C1216.89381,3434.16993 1191.82176,3459.24198 1160.89381,3459.24198 L861.03606,3459.24198 L235,3459.24198 C204.072054,3459.24198 179,3484.31404 179,3515.24198 L179,3972"
        stroke="#fede00"
        strokeWidth={18}
        style={{
          strokeLinecap: "round"
        }}
      />
      <path
        id="main-sftr-align"
        d="M299,3473 C306.732506,3473 313,3466.73251 313,3459 C313,3451.26749 306.732506,3445 299,3445 C291.267494,3445 285,3451.26749 285,3459 C285,3466.73251 291.267494,3473 299,3473 Z"
        stroke="#FDDC00"
        strokeWidth={10}
        fill="#073D61"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="main-form-wrap-align"
        d="M179,4230 C186.732506,4230 193,4223.73251 193,4216 C193,4208.26749 186.732506,4202 179,4202 C171.267494,4202 165,4208.26749 165,4216 C165,4223.73251 171.267494,4230 179,4230 Z"
        stroke="#FDDC00"
        strokeWidth={10}
        fill="#073D61"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="Stroke-15-Copy-4" strokeLinecap="round" strokeLinejoin="round">
        <use fill="#D8D8D8" xlinkHref="#path-1" />
        <use
          stroke="#FDDC00"
          strokeWidth={10}
          fill="#073D61"
          xlinkHref="#path-1"
        />
      </g>
    </g>
  </svg>
);

export default SvgMainBg;




// WEBPACK FOOTER //
// ./frontend/pages/InfographicLanding/MainBG.jsx